import React, { useState, useEffect } from 'react';
import { Phone, Mail, Menu, X } from 'lucide-react';
import { businessInfo } from '../data/mock';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMobileMenuOpen(false);
    }
  };

  const handleCall = () => {
    window.location.href = `tel:${businessInfo.phoneRaw}`;
  };

  return (
    <header 
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled 
          ? 'bg-white/95 backdrop-blur-md shadow-lg' 
          : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center py-4">
          {/* Logo */}
          <div className="flex items-center space-x-3 cursor-pointer" onClick={() => scrollToSection('hero')}>
            <img 
              src="/otl_logo.png" 
              alt="Obućar Tašner Laki Logo" 
              className="h-16 w-auto"
            />
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            <button 
              onClick={() => scrollToSection('hero')}
              className="text-gray-700 hover:text-teal-600 transition-colors font-medium"
            >
              Početna
            </button>
            <button 
              onClick={() => scrollToSection('usluge')}
              className="text-gray-700 hover:text-teal-600 transition-colors font-medium"
            >
              Usluge
            </button>
            <button 
              onClick={() => scrollToSection('o-nama')}
              className="text-gray-700 hover:text-teal-600 transition-colors font-medium"
            >
              O nama
            </button>
            <button 
              onClick={() => scrollToSection('galerija')}
              className="text-gray-700 hover:text-teal-600 transition-colors font-medium"
            >
              Galerija
            </button>
            <button 
              onClick={() => scrollToSection('kontakt')}
              className="text-gray-700 hover:text-teal-600 transition-colors font-medium"
            >
              Kontakt
            </button>
          </nav>

          {/* Contact Buttons */}
          <div className="hidden lg:flex items-center space-x-4">
            <a 
              href={`mailto:${businessInfo.email}`}
              className="flex items-center space-x-2 text-gray-600 hover:text-teal-600 transition-colors"
            >
              <Mail className="w-5 h-5" />
              <span className="text-sm">{businessInfo.email}</span>
            </a>
            <button
              onClick={handleCall}
              className="flex items-center space-x-2 bg-gradient-to-r from-orange-500 to-orange-600 text-white px-6 py-2.5 rounded-lg hover:from-orange-600 hover:to-orange-700 transition-all shadow-md hover:shadow-lg"
            >
              <Phone className="w-4 h-4" />
              <span className="font-semibold">{businessInfo.phone}</span>
            </button>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="md:hidden p-2 rounded-lg hover:bg-gray-100 transition-colors"
          >
            {isMobileMenuOpen ? (
              <X className="w-6 h-6 text-gray-700" />
            ) : (
              <Menu className="w-6 h-6 text-gray-700" />
            )}
          </button>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <div className="md:hidden py-4 border-t border-gray-200 bg-white/95 backdrop-blur-md">
            <nav className="flex flex-col space-y-3">
              <button 
                onClick={() => scrollToSection('hero')}
                className="text-left px-4 py-2 text-gray-700 hover:bg-orange-50 hover:text-orange-500 transition-colors rounded-lg font-medium"
              >
                Početna
              </button>
              <button 
                onClick={() => scrollToSection('usluge')}
                className="text-left px-4 py-2 text-gray-700 hover:bg-orange-50 hover:text-orange-500 transition-colors rounded-lg font-medium"
              >
                Usluge
              </button>
              <button 
                onClick={() => scrollToSection('o-nama')}
                className="text-left px-4 py-2 text-gray-700 hover:bg-orange-50 hover:text-orange-500 transition-colors rounded-lg font-medium"
              >
                O nama
              </button>
              <button 
                onClick={() => scrollToSection('kontakt')}
                className="text-left px-4 py-2 text-gray-700 hover:bg-orange-50 hover:text-orange-500 transition-colors rounded-lg font-medium"
              >
                Kontakt
              </button>
              <div className="pt-3 border-t border-gray-200 px-4 space-y-2">
                <a 
                  href={`mailto:${businessInfo.email}`}
                  className="flex items-center space-x-2 text-gray-600 hover:text-teal-600 transition-colors py-2"
                >
                  <Mail className="w-5 h-5" />
                  <span className="text-sm">{businessInfo.email}</span>
                </a>
                <button
                  onClick={handleCall}
                  className="w-full flex items-center justify-center space-x-2 bg-teal-600 text-white px-6 py-3 rounded-lg hover:bg-teal-700 transition-all shadow-md"
                >
                  <Phone className="w-4 h-4" />
                  <span className="font-semibold">{businessInfo.phone}</span>
                </button>
              </div>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
